import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DebouncedInput from 'Common/Components/v2/DebouncedInput';
import { setBulkUpdateValue } from 'store/Credentials/actions';
import { selectModalBulkUpdateField, selectModalBulkUpdateValue } from 'store/Credentials/selectors';

const Input = () => {
  const dispatch = useDispatch();
  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const bulkUpdateValue = useSelector(selectModalBulkUpdateValue);
  const onChange = (value) => dispatch(setBulkUpdateValue(value));

  return (
    <DebouncedInput
      value={ bulkUpdateValue }
      onChange={ onChange }
      name={ bulkUpdateField }
      title={ bulkUpdateField }
      type="text"
      focusOnMount
    />
  );
};

export default Input;
